import angular from 'angular';
import to from 'await-to-js';
import { setInstitution } from '../../store/features/system/action-creators';
export class InstitutionHelper {
    constructor(Institution, routerHelperFactory, $ngRedux) {
        this.Institution = Institution;
        this.routerHelperFactory = routerHelperFactory;
        this.$ngRedux = $ngRedux;
        this.domain = routerHelperFactory.getSubdomain();
        this.nullInstitution = new Institution({});
    }
    async fetchInstitution() {
        const institutionPromise = this.Institution.findOne({
            filter: {
                where: { domain: String(this.domain) },
                include: [
                    'betaAccesses',
                    'institutionAccess',
                    'institutionMemberships',
                    {
                        relation: 'purchases',
                        scope: {
                            where: { isActive: true },
                            limit: 1,
                        },
                    },
                ],
            },
        }).$promise;
        const [err, institution] = await to(institutionPromise);
        if (err) {
            throw err;
        }
        this.currentInstitution = institution;
        this.$ngRedux.dispatch(setInstitution(institution));
        return institution;
    }
    async getCurrentInstitution() {
        if (!this.domain) {
            return this.nullInstitution;
        }
        if (this.currentInstitution) {
            return this.currentInstitution;
        }
        if (this.currentInstitutionPromise) {
            return this.currentInstitutionPromise;
        }
        this.currentInstitutionPromise = this.fetchInstitution();
        return this.currentInstitutionPromise;
    }
    async getCurrentInstitutionNoCache() {
        if (!this.domain) {
            return this.nullInstitution;
        }
        this.currentInstitution = null;
        this.currentInstitutionPromise = this.fetchInstitution();
        return this.currentInstitutionPromise;
    }
    getCurrentInstitutionId() {
        return this.currentInstitution && String(this.currentInstitution.id);
    }
}
export default angular
    .module('doxy.common.services.institutionHelper', [])
    .service('institutionHelper', InstitutionHelper).name;
